// extracted by mini-css-extract-plugin
export default {"wrapper":"QuickSearch_wrapper__AZScw","flyout":"QuickSearch_flyout__owYbj","dropdown-list":"QuickSearch_dropdown-list__ScI-j"};